import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    document.getElementById('root').scrollIntoView();
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerWidth < 600 ? 150 : 300; // Ajusta para telas menores
      if (window.scrollY > scrollThreshold) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {children}

      {showButton && (
        <button onClick={scrollToTop} className="scroll-to-top">
          <i className="bi bi-arrow-up"></i> {/* Ícone Bootstrap */}
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
